import React from 'react'
import './LineSPF.scss'

function Bar({ height, actions, isDrawReverseActions }) {
	const x = 0
	let y = 0
	const width = '100%'

	const barActions = isDrawReverseActions ? actions.slice().reverse() : actions

	return (
		<svg version='1.1' xmlns='http://www.w3.org/2000/svg' width={width} height={height} preserveAspectRatio='none'>
			{barActions.map((item, index) => {
				if (index > 0 && item.value !== 0) {
					const prevItem = barActions[index - 1]
					y += prevItem.value * height
				}

				/* TODO: think about the best keys for rects */
				return <rect key={index} x={x} y={y} width={width} height={item.value * height} fill={item.color} />
			})}
		</svg>
	)
}

export default Bar
